import React from 'react';
import { DashboardContainer } from '../../components/ui/UtilsLayout';
import { useLocation, useNavigate } from 'react-router-dom';
import { iconsPath } from '../../utils/imagePath';

const NotificationDetails = () => {
  const { state } = useLocation(); // Get notification data passed via navigation state
  const navigate = useNavigate(); // Navigation hook

  return (
    <DashboardContainer>
      <div className="h-full w-full flex gap-3">
        {/* Notification Details Container */}
        <div className="h-full w-full bg-[#1E1F22] p-4 xl:px-16 rounded-lg">
          {/* Back Button */}
          <button
            onClick={() => navigate(-1)}
            className="mb-4 flex gap-2 items-center text-white"
            aria-label="Go back"
          >
            <img src={iconsPath?.leftIcon} alt="Left Icon" />
            <span>Back</span>
          </button>

          {/* Check if state exists before rendering details */}
          {state ? (
            <>
              <div className="text-[24px] font-bold">From: {state?.name}</div>
              <div className="text-[16px] text-[#E9E9E9] font-light">
                {state?.time}
              </div>
              <div className="mt-10 font-semibold">{state?.mess}</div>
              <div className="mt-4 leading-[45px] font-bold text-[16px] w-full">
                {state?.desc}
              </div>
            </>
          ) : (
            <div className="text-center text-gray-400 mt-10">
              No notification details available.
            </div>
          )}
        </div>
      </div>
    </DashboardContainer>
  );
};

export default NotificationDetails;
